import type { AppContextEntry } from '../../chat-app-context'
import { describeEntity, formatCount } from '../../chat-app-context'
import type { HealthStatus } from './tag-health'

export interface TagsAppContextInput {
  /** Selected folder path, `''` for the whole registry. */
  selectedFolder: string
  /** Sidebar text filter, already trimmed by the caller or not. */
  sidebarFilter: string
  healthFilter: 'all' | 'needs_registration' | 'problems' | 'warnings' | 'archived'
  /** Canonical (graph) path of the selected tag — the agent's anchor. */
  selectedTagPath?: string
  selectedTagId?: string
  selectedTagHealth?: HealthStatus
  /** Rows the current folder + health filter resolve to. */
  visibleTagCount: number
  /** Rows rendered on the current page. */
  pageTagCount: number
  currentPage: number
  totalPages: number
}

/**
 * The Tags page keeps folder, selection, health tab, and paging entirely in
 * component state, so without this registration the agent only ever sees
 * "Page: Tags".
 */
export function buildTagsAppContextEntries(input: TagsAppContextInput): AppContextEntry[] {
  const entries: AppContextEntry[] = [
    { key: 'Folder', value: input.selectedFolder === '' ? 'All tags' : input.selectedFolder }
  ]

  if (input.selectedTagPath !== undefined && input.selectedTagPath !== '') {
    entries.push({
      key: 'Selected tag',
      value: describeEntity({
        name: input.selectedTagPath,
        fields: [['health', input.selectedTagHealth]],
        id: input.selectedTagId
      })
    })
  }

  entries.push({ key: 'Health filter', value: input.healthFilter })
  entries.push({
    key: 'Visible page',
    value: `page ${input.currentPage} of ${input.totalPages} — showing ${
      input.pageTagCount
    } of ${formatCount(input.visibleTagCount, 'tag')}`
  })

  const filter = input.sidebarFilter.trim()
  if (filter !== '') entries.push({ key: 'Search', value: filter })

  return entries
}
